import React, { useEffect, useRef, useState } from "react";
import { ThirdPartyCall, ThirdPartyMail, ThirdPartyIcon, AssignedThirdIcon, AssignedDateIcon, LeftOutlinedIcon, RightOutlinedIcon, TruckImgIcon } from "./assets/svgExport";
import { TopWrapper } from "./ThirdPartyStyles";
import { displayValueOrNA, formatDate, formatDateTime } from "./assets/utils";

interface DataCardProps {
  icon: React.ReactNode;
  title: string;
  value: string;
}

const AssignTop = ({ fetchedData, data }: { fetchedData: any; data: any }) => {
  const files = data?.data ?? [];
  const scrollRef = useRef<HTMLDivElement>(null);

  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  const details = fetchedData?.data?.[0];
  const imageList = files;

  const checkScrollPosition = () => {
    if (!scrollRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;

    setIsAtStart(scrollLeft <= 0);
    setIsAtEnd(scrollLeft + clientWidth >= scrollWidth - 1);
  };

  const scrollImages = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const scrollAmount = 480;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const current = scrollRef.current;
    if (!current) return;

    current.addEventListener("scroll", checkScrollPosition);
    checkScrollPosition(); // initialize state

    return () => {
      current.removeEventListener("scroll", checkScrollPosition);
    };
  }, []);

  const DataCard: React.FC<DataCardProps> = ({ icon, title, value }) => (
    <div className="data-card">
      <div className="icon">{icon}</div>
      <span>
        <h1>{title}</h1>
        <h2>{value}</h2>
      </span>
    </div>
  );

  return (
    <TopWrapper>
      <div className="top-header">
        <div className="logo">
          <ThirdPartyIcon />
        </div>

        <div className="contact-info">
          <div className="contact-item">
            <ThirdPartyCall />
            <span>{details?.vehicle_defect_resolution?.[0]?.workshop?.phone_number}</span>
          </div>
          <div className="contact-item">
            <ThirdPartyMail />
            <span>{details?.vehicle_defect_resolution?.[0]?.workshop?.email_id}</span>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="contentWrapper">
          <h1>
            {details?.damage_type?.category}-<span>{details?.damage_type?.sub_category}</span>
          </h1>
          <h2>
            <span className="icon">
              <TruckImgIcon />
            </span>
            {details?.registration_number}
          </h2>
        </div>

        <div className="cardWrapper">
          <DataCard icon={<AssignedThirdIcon />} title="Assigned Date & Time" value={displayValueOrNA(formatDateTime(details?.created_at))} />
          <DataCard icon={<AssignedDateIcon />} title="Required by Date" value={displayValueOrNA(formatDate(details?.vehicle_defect_resolution?.[0]?.required_by))} />
          <DataCard icon={<AssignedDateIcon />} title="Booking Date" value={displayValueOrNA(formatDate(details?.vehicle_defect_resolution?.[0]?.drop_off_date))} />
        </div>

        <div className="imgWrapper">
          <button className={`scroll-btn left ${isAtStart ? "disabled" : ""}`} onClick={() => !isAtStart && scrollImages("left")} disabled={isAtStart}>
            <LeftOutlinedIcon />
          </button>

          <div className="carousel-container" ref={scrollRef}>
            {imageList.map((file: any, index: number) => (
              <img key={index} src={file.url} alt={file.file_name || `Image ${index + 1}`} className="carousel-image" />
            ))}
          </div>

          <button className={`scroll-btn right ${isAtEnd ? "disabled" : ""}`} onClick={() => !isAtEnd && scrollImages("right")} disabled={isAtEnd}>
            <RightOutlinedIcon />
          </button>
        </div>
      </div>
    </TopWrapper>
  );
};

export default AssignTop;
